import React, { useEffect, useState } from 'react';
import { CheckCircle, X } from 'lucide-react';
const purchases = [{
  name: 'Carlos M.',
  city: 'Bogotá',
  country: 'Colombia'
}, {
  name: 'Ana Lucía T.',
  city: 'Guayaquil',
  country: 'Ecuador'
}, {
  name: 'Rodrigo S.',
  city: 'Puerto Montt',
  country: 'Chile'
}, {
  name: 'Marcos T.',
  city: 'Huancayo',
  country: 'Perú'
}, {
  name: 'Sandra P.',
  city: 'Medellín',
  country: 'Colombia'
}, {
  name: 'Diego H.',
  city: 'Manta',
  country: 'Ecuador'
}, {
  name: 'Roberto M.',
  city: 'Cali',
  country: 'Colombia'
}, {
  name: 'Lucía E.',
  city: 'Quito',
  country: 'Ecuador'
}, {
  name: 'Andrés R.',
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  name: 'María C.',
  city: 'Mérida',
  country: 'México'
}, {
  name: 'Fernando L.',
  city: 'Concepción',
  country: 'Chile'
}, {
  name: 'Valeria G.',
  city: 'Lima',
  country: 'Perú'
}, {
  name: 'Daniel A.',
  city: 'Maracaibo',
  country: 'Venezuela'
}, {
  name: 'Laura P.',
  city: 'Guatemala',
  country: 'Guatemala'
}, {
  name: 'Sofía M.',
  city: 'Asunción',
  country: 'Paraguay'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const initial = setTimeout(showNext, 6000);
    return () => clearTimeout(initial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const showNext = () => {
    const random = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrent(random);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 12000) + 12000;
      setTimeout(showNext, nextDelay);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed top-4 right-4 z-50 max-w-[270px] md:max-w-[290px] animate-[slideInRight_0.5s_ease-out]" data-id="element-214">
      <div className="bg-white rounded-xl border-2 border-brand-green p-3 shadow-[0_5px_0_#1A365D,0_10px_24px_rgba(26,54,93,0.25)] flex items-start gap-2.5 relative" data-id="element-215">
        <button onClick={() => setIsVisible(false)} className="absolute -top-2 -right-2 bg-brand-navy text-white rounded-full w-6 h-6 flex items-center justify-center border-2 border-white" aria-label="Cerrar" data-id="element-216">
          <X className="w-3 h-3" strokeWidth={3} data-id="element-217" />
        </button>
        <div className="bg-brand-green rounded-full p-1.5 shrink-0 border-2 border-white" data-id="element-218">
          <CheckCircle className="w-4 h-4 text-white" strokeWidth={3} data-id="element-219" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-220">
          <p className="text-[11px] md:text-xs text-brand-navy font-bold leading-tight mb-0.5" data-id="element-221">
            <span className="font-display font-bold uppercase" data-id="element-222">
              {current.name}
            </span>{' '}
            de{' '}
            <span className="font-bold" data-id="element-223">
              {current.city}, {current.country}
            </span>
          </p>
          <p className="text-[11px] md:text-xs text-brand-ink font-medium leading-tight mb-1" data-id="element-224">
            acaba de comprar el{' '}
            <span className="font-bold text-brand-orange" data-id="element-225">
              Sistema Acuicultura Pro™
            </span>{' '}
            🐟
          </p>
          <p className="text-[9px] md:text-[10px] text-brand-mute font-bold uppercase tracking-widest" data-id="element-226">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-227">{`
        @keyframes slideInRight {
          from { transform: translateX(120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}